import { render, staticRenderFns } from "./InsentifView.vue?vue&type=template&id=8a7b118c&scoped=true"
import script from "./InsentifView.vue?vue&type=script&lang=js"
export * from "./InsentifView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7b118c",
  null
  
)

export default component.exports